export default class {
    constructor(date, chargeCode) {
        this.date = date;
        this.hours = undefined;
        this.chargeCode = chargeCode;
        this.type = 'new';
        this.reason = '';
        this.mode = 0;
    }
}



// WEBPACK FOOTER //
// ./client/pages/timesheet/services/timesheets/timeentry.model.js